import React from 'react';

interface Props {
  message?: string;
}

export default (props: Props) => (
  <div
    className="d-flex align-items-center justify-content-center u-padding-A-m"
    style={{ height: '100%', width: '100%' }}
  >
    {props.message || 'Nothing to display yet.'}
  </div>
);
